module.exports = __webpack_public_path__ + "img/why-outsource-music-licensing-admin.e224d54f.jpg";